import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Upload,
  Button,
  message,
  Space,
  Table,
  Spin,
} from "antd";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { arrayUnion, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import axios from "axios";

const uploadUrl = process.env.REACT_APP_URL_UPLOAD_IMAGE;

const ImageUploadModal = ({ visible, onClose, onSubmit, record }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  console.log("fileList", fileList);

  const checkEdit = record ? true : false;

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        theme: record.theme,
        themeKey: record.themeKey,
        imageTitle: record.imageTitle,
      });
    }
  }, [visible]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const { theme, themeKey, imageTitle } = values;

      const themeRef = doc(db, "themes", themeKey);
      const themeSnap = await getDoc(themeRef);

      if (themeSnap.exists()) {
        // ถ้ามี themeKey อยู่แล้ว => อัปเดตเฉพาะ `theme` และ `imageTitle`
        await updateDoc(themeRef, {
          theme,
          imageTitle,
        });

        message.success("Theme อัปเดตสำเร็จ!");
      } else {
        // ถ้า themeKey ยังไม่มี => สร้างใหม่
        await setDoc(themeRef, {
          theme,
          themeKey, // themeKey เป็น documentId และไม่เปลี่ยนแปลง
          imageTitle,
        });

        // สร้างหรืออัปเดตเอกสาร urlImages ที่มี array เก็บ url ของรูป
        await setDoc(
          doc(db, "urlImages", themeKey),
          { urls: [] },
          { merge: true }
        );

        message.success("Theme สร้างสำเร็จ!");
      }

      console.log("Document successfully written or updated!");

      onSubmit(values); // ส่งค่ากลับไปยัง component หลัก (ถ้าจำเป็น)
      form.resetFields();
    } catch (error) {
      console.error("Error adding or updating document: ", error);
      message.error("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    }
  };

  const handleUpload = async () => {
    console.log("🔥 uploadFiles called with:", fileList);

    setUploading(true); // ✅ เริ่มโหลด

    try {
      const themeKey = record?.themeKey; // เปลี่ยนค่า themeKey ตามต้องการ
      const uploadedUrls = [];

      for (const file of fileList) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("theme", themeKey);

        const response = await axios.post(uploadUrl, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        console.log("✅ Upload successful:", response.data);
        if (response.data.success && response.data.url) {
          uploadedUrls.push(response.data.url);
        }
      }

      if (uploadedUrls.length > 0) {
        const urlRef = doc(db, "urlImages", themeKey);
        await updateDoc(urlRef, {
          urls: arrayUnion(...uploadedUrls), // ✅ เพิ่ม URL ลงใน `urls` array
        });

        message.success("🎉 อัปโหลดไฟล์สำเร็จ!");
        setFileList([]); // ✅ เคลียร์ไฟล์ที่อัปโหลดแล้ว
      } else {
        message.warning("⚠️ ไม่มีไฟล์ที่อัปโหลดสำเร็จ");
      }
    } catch (error) {
      console.error("❌ Upload error:", error);
      message.error("❌ เกิดข้อผิดพลาดในการอัปโหลดไฟล์");
      setUploading(false); // ✅ จบโหลด
    } finally {
      setUploading(false); // ✅ จบโหลด
    }
  };

  const props = {
    listType: "text",
    name: "file",
    multiple: true,
    showUploadList: false,
    action: "",
    beforeUpload: (file, fileList) => {
      setFileList((prevList) => {
        const newFiles = [...prevList, ...fileList];
        const uniqueFiles = newFiles.filter(
          (file, index, self) =>
            index ===
            self.findIndex((f) => f.name === file.name && f.size === file.size)
        );
        return uniqueFiles;
      });
      return false;
    },
    fileList,
  };

  const handleDelete = (file) => {
    const index = fileList.indexOf(file);
    const newFileList = fileList.slice();
    newFileList.splice(index, 1);
    setFileList(newFileList);
  };

  return (
    <Modal
      title="Create Theme"
      open={visible}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        setFileList([]);
        onClose();
      }}
      styles={{
        body: {
          height: checkEdit ? "500px" : "250px",
        },
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="theme"
          label="Theme Name"
          rules={[{ required: true, message: "Please enter a theme" }]}
        >
          <Input placeholder="Enter theme" />
        </Form.Item>
        <Form.Item
          label="Theme Key"
          name="themeKey"
          rules={[
            {
              required: checkEdit ? false : true,
              message: "Please enter a theme key",
            },
          ]}
        >
          <Input disabled={checkEdit} placeholder="Enter theme key" />
        </Form.Item>
        <Form.Item
          label="Image Title"
          name="imageTitle"
          rules={[{ required: true, message: "Please enter a title" }]}
        >
          <Input placeholder="Enter image title" />
        </Form.Item>
      </Form>
      {checkEdit ? (
        <Spin spinning={uploading}>
          <div style={{ height: "140px" }}>
            <Space
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                paddingBottom: "16px",
              }}
            >
              <Upload {...props}>
                <Button icon={<UploadOutlined />}>Upload Image</Button>
              </Upload>
              <Button
                type="primary"
                onClick={handleUpload}
                disabled={fileList.length === 0}
                loading={uploading}
              >
                {uploading ? "Uploading" : "Start Upload"}
              </Button>
            </Space>

            <Table
              size="small"
              rowKey={(record) => record.uid}
              bordered
              columns={[
                { title: "Name", dataIndex: "name", key: "name", width: 300 },
                {
                  title: "Actions",
                  key: "actions",
                  render: (_, record) => (
                    <DeleteOutlined
                      style={{ color: "red" }}
                      onClick={() => handleDelete(record)}
                    />
                  ),
                },
              ]}
              dataSource={fileList}
              pagination={false}
              scroll={fileList.length > 0 ? { y: 140 } : undefined}
            />
          </div>
        </Spin>
      ) : null}
    </Modal>
  );
};

export default ImageUploadModal;
